<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dHsPoS/tc-custom/9781468302141.jpg?1734322223851" alt="This image is the cover for the book Tarabas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tarabas
      </h1>
      <p class="bookDescription body article font2">
        <b>This modern fable of the Russian Revolution from the author of <i>The Radetzy March</i> follows the tragic life of a peasant who seeks meaning in violence.</b><br/>  <br/> A Russian peasant, Nicholas Tarabas learns in his youth from a gypsy that he is destined to be both a murderer and saint. After fleeing to America under suspicion of a crime, he soon returns to fight for his homeland in World War I. Finding purpose in the army, he becomes a merciless officer, terrorizing townspeople—especially Jews.<br/>  <br/> Already, the first half of the gypsy’s prophecy has tragically come true. Only after the war and the revolution does Tarabas repent, devoting the rest of his life to attaining forgiveness for his crimes against his fellow man. It is Roth’s special gift that, as Tarabas fulfills his tragic destiny, the larger movements of history find their perfect expression in the fate of one man.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Roth
      </h2>
      
      <p class="authorDescription body article">Joseph Roth was born in 1894 in a small Galician town on the eastern borders of the Hapsburg Empire. After serving in the Austro-Hungarian army from 1916 to 1918, he worked as a journalist in Vienna and in Berlin. He died in Paris in 1939, leaving behind thirteen novels as well as many stories and essays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?347b8639